var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEscs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "129.5px",
    height: "156.5px",
    viewBox: "0 0 129.5 156.5",
    style: {
      enableBackground: "new 0 0 129.5 156.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\r\n\t.st0{fill:#4D4D4D;}\r\n\t.st1{fill:#666666;}\r\n\t.st2{fill:#CCCCCC;}\r\n\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "100,32.8 100,107.1 126,120.7 126,16.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "99.8,101.1 23,126.5 28.8,153.2 126,120.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29,56 3,56 3,23 29,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3,22.6 28.3,3.2 126,15.9 100.4,35.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3,22.5 3,135 29,153.2 29,49.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscs);
export default __webpack_public_path__ + "static/media/escs.2f12c0d4232a3478ea0245959ce848c0.svg";
export { ForwardRef as ReactComponent };